import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';
import enServices from './locales/en/services.json';
import enWork from './locales/en/work.json';
import enInsights from './locales/en/insights.json';
import enArticles from './locales/en/articles.json';
import enContact from './locales/en/contact.json';
import enFaq from './locales/en/faq.json';
import enPrivacy from './locales/en/privacy.json';
import enTerms from './locales/en/terms.json';
import enCookies from './locales/en/cookies.json';

// French
import frCommon from './locales/fr/common.json';
import frHome from './locales/fr/home.json';
import frAbout from './locales/fr/about.json';
import frServices from './locales/fr/services.json';
import frWork from './locales/fr/work.json';
import frInsights from './locales/fr/insights.json';
import frArticles from './locales/fr/articles.json';
import frContact from './locales/fr/contact.json';
import frFaq from './locales/fr/faq.json';
import frPrivacy from './locales/fr/privacy.json';
import frTerms from './locales/fr/terms.json';
import frCookies from './locales/fr/cookies.json';

// German
import deCommon from './locales/de/common.json';
import deHome from './locales/de/home.json';
import deAbout from './locales/de/about.json';
import deServices from './locales/de/services.json';
import deWork from './locales/de/work.json';
import deInsights from './locales/de/insights.json';
import deArticles from './locales/de/articles.json';
import deContact from './locales/de/contact.json';
import deFaq from './locales/de/faq.json';
import dePrivacy from './locales/de/privacy.json';
import deTerms from './locales/de/terms.json';
import deCookies from './locales/de/cookies.json';

export const SUPPORTED_LANGUAGES = ['en', 'fr', 'de'];

const resources = {
  en: {
    common: enCommon,
    home: enHome,
    about: enAbout,
    services: enServices,
    work: enWork,
    insights: enInsights,
    articles: enArticles,
    contact: enContact,
    faq: enFaq,
    privacy: enPrivacy,
    terms: enTerms,
    cookies: enCookies,
  },
  fr: {
    common: frCommon,
    home: frHome,
    about: frAbout,
    services: frServices,
    work: frWork,
    insights: frInsights,
    articles: frArticles,
    contact: frContact,
    faq: frFaq,
    privacy: frPrivacy,
    terms: frTerms,
    cookies: frCookies,
  },
  de: {
    common: deCommon,
    home: deHome,
    about: deAbout,
    services: deServices,
    work: deWork,
    insights: deInsights,
    articles: deArticles,
    contact: deContact,
    faq: deFaq,
    privacy: dePrivacy,
    terms: deTerms,
    cookies: deCookies,
  },
};

// Detector: localStorage only. No browser/navigator sniffing.
// If no stored choice, fall back to English — English is the default per spec.
const detectionOptions = {
  order: ['localStorage'],
  lookupLocalStorage: 'i18nextLng',
  caches: ['localStorage'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: false,
    load: 'languageOnly',
    detection: detectionOptions,
    ns: [
      'common', 'home', 'about', 'services', 'work', 'insights',
      'articles', 'contact', 'faq', 'privacy', 'terms', 'cookies',
    ],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    returnObjects: true,
    react: { useSuspense: false },
  });

// Keep <html lang> in sync.
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language || 'en';
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
  });
}

export default i18n;
